import Select from "react-select";

const SelectFilter = ({ label, name, value, options, ...props }) => (
  <Select
    className="p-1 text-md w-48"
    inputId={name}
    name={name}
    value={value}
    options={options}
    isClearable
    {...props}
  ></Select>
);

export default SelectFilter;
